import { useEffect, useState } from "react";
import { api } from "../App";

const REFRESH_MS = 30000;

export default function useLiveAnalytics(endpoint, params, active = true) {
  const key = JSON.stringify(params);
  const [state, setState] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!active) return undefined;
    let disposed = false, running = false, timer;
    setFailed(false);
    const load = async () => {
      clearTimeout(timer);
      if (disposed || running || document.visibilityState === "hidden") return;
      running = true;
      try {
        const { data } = await api.get(endpoint, { params: JSON.parse(key) });
        if (!disposed) { setState({ key, report: data }); setFailed(false); }
      } catch {
        if (!disposed) setFailed(true);
      } finally {
        running = false;
        if (!disposed) timer = setTimeout(load, REFRESH_MS);
      }
    };
    load();
    document.addEventListener("visibilitychange", load);
    return () => { disposed = true; clearTimeout(timer); document.removeEventListener("visibilitychange", load); };
  }, [key, active, endpoint]);
  const report = state?.key === key ? state.report : null;
  return { report, failed };
}
